import { FREELANCECLIENTSECONDARY } from "../../ENVIRONMENT";

// api for freelance secondary list
function freesecondaryList(token) {
  const response = fetch(FREELANCECLIENTSECONDARY, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freesecondaryList };
